import { gql } from "@apollo/client";

const UPDATE_TOR = gql`
    mutation updateToR($torID: String!, $laID: String!, $studyPeriodStart: String, $studyPeriodEnd: String){
        updateToR(torID: $torID, laID: $laID, studyPeriodStart: $studyPeriodStart, studyPeriodEnd: $studyPeriodEnd) 
  }
`;

export default UPDATE_TOR;
